export const ui = {
  /** `Modal`'s close button (icon-only, so it needs an `aria-label`). */
  close: 'Close',
  /** `Spinner`'s `role="status"` text for screen readers — visually hidden. */
  loading: 'Loading…',
  /** `Dropdown`'s toggle button, when the caller does not supply its own
   * `aria-label` (e.g. an icon-only trigger). */
  openMenu: 'Open menu',
} as const;
